export enum ClasseGrupoProcedimentoEnum {
  ADMINISTRATIVO_ELEITORAL = 'ADMINISTRATIVO_ELEITORAL',
  CARTA = 'CARTA',
  CONHECIMENTO = 'CONHECIMENTO',
  EXECUCAO_JUDICIAL = 'EXECUCAO_JUDICIAL',
  EXECUCAO_TITULO_EXTRAJUDICIAL = 'EXECUCAO_TITULO_EXTRAJUDICIAL',
  INCIDENTE_EXECUCAO = 'INCIDENTE_EXECUCAO',
  INDEFINIDO = 'INDEFINIDO',
  OUTROS = 'OUTROS',
  PROCEDIMENTO_INVESTIGATORIO = 'PROCEDIMENTO_INVESTIGATORIO',
  VARIAVEL  = 'VARIAVEL'
}
